<div class="menu-chips-line" *ngIf="hasMenuView$ | async">
  <mat-button-toggle-group *ngIf="!!selectedMenuSectionId"  class="menu-chips-line-buttons" (change)="onSelected($event)"
                           [value]="selectedMenuSectionId">
    <div *ngFor="let menuSection of menuSections" class="button-wrap">
      <mat-button-toggle
        *ngIf="isShowDeleted || !menuSection.isDeleted"
        [value]="menuSection.id"
        (contextmenu)="onContextMenu($event, menuSection, null)"
        [ngClass] = "{ isDeleted: menuSection.isDeleted }"
      >{{menuSection.name}}</mat-button-toggle>
    </div>
    <div *ngFor="let menuBackup of menuBackups" class="button-wrap backup-style">
      <mat-button-toggle
        [value]="menuBackup.id"
        (contextmenu)="onContextMenu($event, null, menuBackup)"
        [matTooltip]="'backup'"
      >{{menuBackup.name}}</mat-button-toggle>
    </div>
  </mat-button-toggle-group>

  <div style="visibility: hidden; position: fixed"
       [style.left]="contextMenuPosition.x"
       [style.top]="contextMenuPosition.y"
       [matMenuTriggerFor]="contextMenu">
  </div>
  <button *ngIf="hasMenuEdit$ | async" class="menu-chips-line-new" mat-button (click)="onAddNewMenu()">
    <mat-icon>add</mat-icon>
    {{'MENU.NEW_MENU' | translate}}
  </button>
  <mat-slide-toggle *ngIf="hasMenuEdit$ | async" [checked]="isShowDeleted"
                    (toggleChange)="switchShowDeleted()">{{ 'LOCATION.DISPLAY_DELETED' | translate }}</mat-slide-toggle>


</div>

<div *ngIf="getCurrentBackupInfo()">
  <p *ngFor="let backupInfo of getCurrentBackupInfo()">
    <span>{{backupInfo}}</span>
  </p>
</div>

<mat-menu #contextMenu="matMenu">
  <ng-template matMenuContent let-item="menuData">
    <button *ngIf="isMenuSectionContext() && (hasMenuEdit$ | async)" mat-menu-item (click)="onEdit(item)">
      <mat-icon>edit</mat-icon>
      <span>{{ 'COMMON.EDIT' | translate }}</span>
    </button>
    <button *ngIf="isMenuSectionContext() && (hasMenuEdit$ | async)" mat-menu-item (click)="createBackup()">
      <mat-icon>edit</mat-icon>
      <span>{{ 'MENU.CREATE_BACKUP' | translate }}</span>
    </button>
    <button *ngIf="!isMenuSectionContext() && (hasMenuConversionFileDownload$ | async)" mat-menu-item (click)="downloadMenuByName()">
      <mat-icon>edit</mat-icon>
      <span>{{ 'MENU.DOWNLOAD' | translate }}</span>
    </button>
    <button *ngIf="(hasMenuView$ | async)" mat-menu-item (click)="onCopyIdClick(item)">
      <mat-icon>file_copy</mat-icon>
      <span>{{ 'MENU.ID_COPY' | translate }}</span>
    </button>
    <button *ngIf="isMenuSectionContext() && (hasMenuEdit$ | async)" mat-menu-item (click)="onCopyMenuClick(item)">
      <mat-icon>file_copy</mat-icon>
      <span>{{ 'MENU.COPY_MENU' | translate }}</span>
    </button>
    <button *ngIf="isMenuSectionContext() && (hasMenuUploadScheduleEdit$ | async)" mat-menu-item (click)="onClickSchedules(item)">
      <mat-icon>schedule</mat-icon>
      <span>{{ 'MENU.SCHEDULES' | translate }}</span>
    </button>
    <button *ngIf="isMenuSectionContext() && (hasMenuEdit$ | async)"
            mat-menu-item (click)="onClickMigrateLegacyToV2()">
      <mat-icon>swap_horiz</mat-icon>
      <span>{{ 'MENU.MIGRATE_RELATED_PRODUCTS_LEGACY_TO_V2' | translate }}</span>
    </button>
    <button *ngIf="isMenuSectionContext() && (hasMenuEdit$ | async) && enableRelatedProductsV3"
            mat-menu-item (click)="onClickMigrateV2ToV3()">
      <mat-icon>swap_horiz</mat-icon>
      <span>{{ 'MENU.MIGRATE_RELATED_PRODUCTS_V2_TO_V3' | translate }}</span>
    </button>
    <button mat-menu-item (click)="onDeleteMenuClick(item)"
            *ngIf="!isDeleted(item) && (hasMenuDelete$ | async)">
      <mat-icon>delete</mat-icon>
      <span>{{ 'COMMON.DELETE' | translate }}</span>
    </button>
    <button mat-menu-item (click)="onRestoreMenuClick(item)"
            *ngIf="isDeleted(item) && (hasMenuDelete$ | async)">
      <mat-icon>restore</mat-icon>
      <span>{{ 'COMMON.RESTORE' | translate }}</span>
    </button>
  </ng-template>
</mat-menu>
